export default "__VITE_ASSET__BAmIyqn5__"